import React from 'react'
import { timeSinceInDays } from '@spectral/types'

const PassedPeriod = ({ createdAt }) => {
  return <> {timeSinceInDays(createdAt)}</>
}

export default PassedPeriod
